import { useState } from 'react';
import { css } from '@emotion/react';

import { useDetermineMobile } from '@myrealtrip/device-detect';

import styled from '@emotion/styled';
import { HeaderTheme } from '../../../constants/header';
import { HeaderThemeType } from '../../../constants/header';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import { globalVariables } from '../../../shared/designSystem/constants';

import DefaultLocalNavItems from './DefaultLocalNavItems';
import MainPageLocalNavItems from './MainPageLocalNavItems';
import { useEffect } from 'react';

function isHideLnbInMobile(pathName: string) {
  const hideLnbPages = ['/cities', '/countries'];
  const isOffer = /\/offers\/[0-9]+\/?$/g.test(pathName);
  const isPayment = /\/offers\/[0-9]+\/reservations\/new$/g.test(pathName);
  // 3.0 payment
  const isOrder = /\/order\/[^/]+$/g.test(pathName);
  const isOrderPending = /\/order\/[0-9]+\/pending+/g.test(pathName);
  const isStayDetail = /\/accommodations\/stays\/[0-9]+\/?$/g.test(pathName);
  const isMainPage = /^\/$|\/main$/g.test(pathName);

  return (
    hideLnbPages.includes(pathName) ||
    isOffer ||
    isPayment ||
    isOrder ||
    isOrderPending ||
    isStayDetail ||
    isMainPage
  );
}

export default function LNB() {
  const { theme, isFlightMode, excludeLnb, isMainPage } = useLayoutHeaderContext();
  const isMobile = useDetermineMobile();
  const canShowMainPageLocalNavBar = !isMobile && isMainPage;
  const canShowDefaultLocalNavBar = isFlightMode || !isMainPage;
  const isHideMainPageBorder = isMobile && isMainPage;

  const [needHideLnb, setNeedHideLnb] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname;
      setNeedHideLnb(isMobile && isHideLnbInMobile(pathname));
    }
  }, [isMobile]);

  if (needHideLnb || excludeLnb) {
    return null;
  }

  return (
    <Container colorTheme={theme} noBorder={isHideMainPageBorder}>
      {canShowMainPageLocalNavBar && (
        <Inner>
          <MainPageLocalNavItems />
        </Inner>
      )}
      {canShowDefaultLocalNavBar && (
        <Inner>
          <DefaultLocalNavItems />
        </Inner>
      )}
    </Container>
  );
}

const LNB_THEME_STYLE = {
  [HeaderTheme.blue]: css`
    border-bottom: 1px solid ${globalVariables.blue_600};
  `,
  [HeaderTheme.white]: css`
    border-bottom: 1px solid ${globalVariables.gray_200};
  `,
  [HeaderTheme.transparent]: css`
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  `,
};

const Container = styled.div<{
  colorTheme: HeaderThemeType;
  noBorder?: boolean;
}>`
  width: 100%;

  ${({ colorTheme }) => LNB_THEME_STYLE[colorTheme]};
  ${({ noBorder }) => noBorder && 'border-bottom: 0;'};
`;

const Inner = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  max-width: 1060px;
  margin: 0 auto;
`;
